import { UserEventBase } from './user.event.base';

export class UserEventInvite extends UserEventBase {
  public event: number;
}



